<template>
  <div
    class="d-flex align-center"
    style="min-height: 40vh"
  >
    <v-progress-circular
      class="mx-auto"
      indeterminate
      color="#72AFE7"
    ></v-progress-circular>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>